import { makeStyles } from '@material-ui/core';

export default makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    padding: '1.5rem 1.5rem 5rem',
    borderRadius: '0.5rem',
  },
});
